module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_02-1e9d92f6ea7f157f0ce1324b84d24371.webp";